'use client'
import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import Link from "next/link";
import LargeSwiperImage from '@components/LargeSwiperImage'


const TransportCardSlider = ({ title, description, btsStations, url, lang }) => {

    return (
        <section className='w-full lg:pl-0 pl-3 my-6 pb-3 border-b-[1px] border-b-forth'>
            {url ? (
                <Link href={`/${url}`}>
                    <h2 className='carousel-title-align'>{title?.[lang]}</h2>
                </Link>
            ) : (
                <h2 className='carousel-title-align'>{title?.[lang]}</h2>
            )}
            {description?.[lang]?.trim() && (
                <p className='carousel-description-align'>{description?.[lang]}</p>
            )}
            <div className='md:block hidden my-6'>
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={16}
                    slidesPerView={4}
                    className="mt-2"
                >
                    {btsStations && btsStations.map((bts, index) => (
                        <SwiperSlide key={index}>
                            <LargeSwiperImage location={bts.id} type={'bts'} color={bts?.colorCode} title={`${bts.type.toUpperCase()} ${bts.stationName}`} imageSrc={bts?.coverImage} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="md:hidden block flex-row flex-wrap my-3">
                <Swiper
                    navigation={true}
                    modules={[Navigation]}
                    pagination={{
                        clickable: true,
                    }}
                    spaceBetween={16}
                    slidesPerView={1.5}
                    className="mt-2"
                >
                    {btsStations && btsStations.map((bts, index) => (
                        <SwiperSlide key={index}>
                            <LargeSwiperImage location={bts.id} type={'bts'} color={bts?.colorCode} title={`${bts.type.toUpperCase()} ${bts.stationName}`} imageSrc={bts?.coverImage} />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </section>
    )
}

export default TransportCardSlider